import { MenuItem } from '../../../shared/components';

export const menuItems: Array<MenuItem> = [
  {
    label: 'Clients',
    routerLink: null,
    viewPermission: 'clientsModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-user',
    toggle: 'close',
    submenu: [
      {
        label: 'Client Lookup',
        viewPermission: 'clientsModule.lookup',
        routerLink: 'clients',
        iconType: 'letter',
        iconName: 'cl'
      },
      {
        label: 'Universal Search',
        viewPermission: 'clientsModule.universalSearch',
        routerLink: 'clients/universal-search',
        iconType: 'letter',
        iconName: 'us'
      }
    ]
  },
  {
    label: 'Charters',
    routerLink: null,
    viewPermission: 'charterSalesModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-globe-americas',
    toggle: 'close',
    submenu: [
      {
        label: 'Opportunities',
        viewPermission: 'charterSalesModule.opportunities',
        routerLink: 'charters/opportunities',
        iconType: 'letter',
        iconName: 'co'
      },
      {
        label: 'My Opportunities',
        viewPermission: 'charterSalesModule.myOpportunities',
        routerLink: 'charters/opportunities/my',
        iconType: 'letter',
        iconName: 'my'
      },
      {
        label: 'New Opportunity',
        viewPermission: 'charterSalesModule.newOpportunities',
        routerLink: 'charters/opportunities/new',
        iconType: 'letter',
        iconName: 'o'
      }
    ]
  },
  {
    label: 'Marketplace',
    routerLink: null,
    viewPermission: 'marketplaceModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-shopping-cart',
    toggle: 'close',
    submenu: [
      {
        label: 'Requests',
        viewPermission: 'marketplaceModule.overall',
        routerLink: 'marketplace/requests',
        iconType: 'letter',
        iconName: 'mr'
      },
      {
        label: 'New Request',
        viewPermission: 'marketplaceModule.overall',
        routerLink: 'marketplace/new-request',
        iconType: 'letter',
        iconName: 'nr'
      }
    ]
  },
  {
    label: 'Resources',
    routerLink: null,
    viewPermission: 'resourceModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-cubes',
    toggle: 'close',
    submenu: [
      {
        label: 'Aircraft',
        viewPermission: 'resourceModule.aircraft',
        routerLink: 'resource-mgmt/aircraft',
        iconType: 'letter',
        iconName: 'ac'
      },
      {
        label: 'Airports',
        viewPermission: 'resourceModule.airports',
        routerLink: 'resource-mgmt/airports',
        iconType: 'letter',
        iconName: 'ap'
      },
      {
        label: 'Application Configs',
        viewPermission: 'resourceModule.applicationConfigs',
        routerLink: 'resource-mgmt/configs',
        iconType: 'letter',
        iconName: 'c'
      },
      {
        label: 'Areas',
        viewPermission: 'resourceModule.areas',
        routerLink: 'resource-mgmt/areas',
        iconType: 'letter',
        iconName: 'ar'
      },
      {
        label: 'Markets',
        viewPermission: 'resourceModule.markets',
        routerLink: 'resource-mgmt/markets',
        iconType: 'letter',
        iconName: 'mr'
      },
      {
        label: 'Operators',
        viewPermission: 'resourceModule.operators',
        routerLink: 'resource-mgmt/operators',
        iconType: 'letter',
        iconName: 'op'
      },
      {
        label: 'Operator Approvals',
        viewPermission: ['resourceModule.operatorApprovals', 'resourceModule.oneOffApprovals'],
        routerLink: 'resource-mgmt/operator-approvals',
        iconType: 'letter',
        iconName: 'oa'
      },
      {
        label: 'Regions',
        viewPermission: 'resourceModule.regions',
        routerLink: 'resource-mgmt/regions',
        iconType: 'letter',
        iconName: 'rg'
      },
      {
        label: 'Vendors',
        viewPermission: 'resourceModule.vendors',
        routerLink: 'resource-mgmt/vendors',
        iconType: 'letter',
        iconName: 'vn'
      },
      {
        label: 'Users',
        viewPermission: 'resourceModule.users',
        routerLink: 'resource-mgmt/users',
        iconType: 'letter',
        iconName: 'u'
      }
    ]
  },
  {
    label: 'Sales',
    routerLink: null,
    viewPermission: 'salesModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-users',
    toggle: 'close',
    submenu: [
      {
        label: 'New Order',
        viewPermission: 'salesModule.new',
        routerLink: 'sales/orders/new',
        iconType: 'letter',
        iconName: 'n'
      },
      {
        label: 'Orders',
        viewPermission: 'salesModule.orders',
        routerLink: 'sales/orders',
        iconType: 'letter',
        iconName: 'o'
      },
    ]
  },
  {
    label: 'Sourcing',
    routerLink: null,
    viewPermission: 'sourcingModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-money-check-alt',
    toggle: 'close',
    submenu: [
      {
        label: 'Requests',
        viewPermission: 'sourcingModule.requests',
        routerLink: 'sourcing/requests',
        iconType: 'letter',
        iconName: 'sr'
      },
      {
        label: 'My Requests',
        viewPermission: 'sourcingModule.myRequests',
        routerLink: 'sourcing/requests/my',
        iconType: 'letter',
        iconName: 'my'
      },
      {
        label: 'Last Look',
        viewPermission: 'sourcingModule.requests',
        routerLink: 'sourcing/last-look',
        iconType: 'letter',
        iconName: 'll'
      },
      {
        label: 'Sent Emails',
        viewPermission: 'sourcingModule.sentEmails.fullList',
        routerLink: 'sourcing/sent-emails',
        iconType: 'letter',
        iconName: 'se'
      }
    ]
  },
  {
    label: 'Task Mgmt',
    routerLink: null,
    viewPermission: 'taskMgmtModule.overall',
    iconType: 'fal',
    iconName: 'fal fa-tasks-alt',
    toggle: 'close',
    submenu: [
      {
        label: 'Task Dashboard',
        viewPermission: 'taskMgmtModule.tasks',
        routerLink: 'task-mgmt/tasks',
        iconType: 'letter',
        iconName: 'td'
      }
    ]
  },
];
